import React, { useEffect, useState, useCallback } from 'react';
import api from '../api/client';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { PageHeader } from '../components/PageHeader';
import { Badge } from '../components/ui/badge';
import { formatDateTime, ROLE_LABELS } from '../lib/format';
import { Search, ScrollText } from 'lucide-react';

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState('');

  const load = useCallback(async () => setLogs((await api.get('/audit-logs')).data), []);
  useEffect(() => { load(); }, [load]);

  const filtered = logs.filter((l) => {
    if (!search) return true;
    const s = search.toLowerCase();
    return [l.action, l.entity, l.username, l.entity_id].some((v) => String(v || '').toLowerCase().includes(s));
  });

  return (
    <div className="space-y-4">
      <PageHeader title="Audit Trail" description="Immutable log of all critical actions across the system (Super Admin only)." />
      <Card><CardContent className="p-4">
        <div className="relative max-w-md"><Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" /><Input className="pl-9" placeholder="Search action, user, entity..." value={search} onChange={(e) => setSearch(e.target.value)} /></div>
      </CardContent></Card>
      <Card><CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b text-left text-slate-600"><tr><th className="p-3">Timestamp <span className="text-[10px] font-normal text-slate-400">(GMT+8)</span></th><th className="p-3">User</th><th className="p-3">Action</th><th className="p-3">Entity</th><th className="p-3">Entity ID</th><th className="p-3">Details</th></tr></thead>
          <tbody className="divide-y">
            {filtered.length === 0 ? <tr><td colSpan={6} className="p-8 text-center text-slate-500"><ScrollText className="h-8 w-8 mx-auto text-slate-300" /><div className="mt-2">No audit logs.</div></td></tr> :
              filtered.map((l) => (
                <tr key={l.id} className="table-row-hover">
                  <td className="p-3 text-xs whitespace-nowrap">{formatDateTime(l.timestamp)}</td>
                  <td className="p-3"><div className="text-xs font-mono">{l.username}</div><div className="text-[10px] text-slate-500">{ROLE_LABELS[l.role]}</div></td>
                  <td className="p-3"><Badge variant="secondary">{l.action}</Badge></td>
                  <td className="p-3">{l.entity}</td>
                  <td className="p-3 font-mono text-[10px]">{(l.entity_id || '').slice(0, 8)}...</td>
                  <td className="p-3 text-xs max-w-md truncate text-slate-500">{JSON.stringify(l.details || {}).slice(0, 120)}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </CardContent></Card>
    </div>
  );
};

export default AuditLogs;
